import $ from 'init/jquery'
import { isMobile } from 'init/is-mobile'
import { View } from '../../components/view'
import { Popup } from '../../libs/popup'
import { Defaults } from 'es-decorators'
import { preloader } from 'init/preloader'
import { fader } from 'init/fader'
import { getTemplate } from 'helpers/template-helper'
import { currentCurrency } from 'init/current-currency'
import { fractionNumber } from 'helpers/number-helpers'
import { goToCheckout } from 'helpers/redirect-helper'

/**
 * Представление попапа заказа товаров с удаленного склада меньше минимума со страницы корзины
 */
@Defaults({
  events: {
    'click .js-to-checkout': 'goToCheckout',
  },
})
export class ItemsPopupView extends View {
  /** @inheritDoc */
  run () {
    this.template = getTemplate('#popup-items-template')
    this.initPopup()
  }

  /**
   * Инициализация попапа
   */
  initPopup () {
    this.popup = new Popup(this.$el)
    this.popup.addEventListener(
      Popup.EventType.BEFORE_CLOSE, function () {
        this.beforePopupClose()
        fader.hide()
        if (isMobile) {
          $('body').removeClass('body_mobile_hidden')
        }
      }.bind(this)
    )
    this.popup.addEventListener(
      Popup.EventType.BEFORE_OPEN,
      function () {
        // Показываем по центру экрана
        const top = ($(window).height() - this.$el.outerHeight()) / 2 + window.pageYOffset
        const right = ($(window).width() - this.$el.outerWidth()) / 2
        if (isMobile) {
          $('body').addClass('body_mobile_hidden')
        } else {
          this.$el.css({
            right: right,
            top: top,
          })
        }
      }.bind(this)
    )
  }

  /**
   * Действия перед закрытием попапа
   * (переопределяется в потомках)
   */
  beforePopupClose () {

  }

  /**
   * Загрузить товары с удаленного склада и показать прелодаер.
   * После получения товаров скрываем прелоадер и показываем попап.
   */
  fetchAndShow () {
    preloader.render()
    preloader.listenToOnce(this.collection, 'sync', preloader.remove)
    this.listenToOnce(this.collection, 'sync', this.render)
    this.collection.fetch()
  }

  /** @inheritDoc */
  render () {
    const templateData = {
      items: this.collection.toJSON(),
      currencySign: currentCurrency.sign,
      fractionNumber: fractionNumber,
    }

    this.$('.js-content-container').html(this.template(templateData))
    this.open()
  }

  /**
   * Рендерим прелоадер, скрываем попап и фейдер.
   * Не используем  popup.close(), чтобы не открывался попап о минимальной сумме заказа
   */
  beforeButtonAction () {
    preloader.render()
    this.$el.addClass('not_display')
    fader.hide()
  }

  /**
   * Отправляем на оформление заказа товаров с быстрой доставкой
   */
  goToCheckout () {
    this.beforeButtonAction()
    goToCheckout({ is_fast_delivery: true })
  }

  /**
   * Открываем попап
   */
  open () {
    this.popup.open()
    fader.show()
  }
}
